module.exports = __webpack_public_path__ + "static/img/logo1.47c5e278.png";